import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageModalComponent } from './messagemodal';
import { TanzeelNotificationComp } from './tanzeel.notification.comp';

@NgModule({
  imports: [CommonModule],
  declarations: [MessageModalComponent, TanzeelNotificationComp],
  exports: [MessageModalComponent, TanzeelNotificationComp],
})
export class TanzeelMessagingModule {}
